import ServiceBase from '../../ServiceBase';
import economyProxy from '../../../proxies/market/market-calendar/EconomyProxy';

class EconomyService extends ServiceBase {
  getListEconomy(params, source) {
    return this.applyMemoryCache('EconomyService.GetEconomy', params)(() =>
      economyProxy.getListEconomy(params, source),
    );
  }
}

const economyService = new EconomyService();
export default economyService;
